module.exports = __webpack_public_path__ + "img/3.7c8e27e9.png";